module.exports = __webpack_public_path__ + "h5/img/income.dd23383e.png";